export default __webpack_public_path__ + "static/media/drop.a8a2883a.svg";